import { render, staticRenderFns } from "./boxed.vue?vue&type=template&id=6d9c6dc9&scoped=true"
var script = {}
import style0 from "./boxed.vue?vue&type=style&index=0&id=6d9c6dc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9c6dc9",
  null
  
)

export default component.exports